import {
  IoIosCall,
  IoIosMail,
  IoIosPeople,
  IoMdCafe,
  IoMdRestaurant,
  IoIosPaper
} from 'react-icons/io'

const TaskIcons = {
  CALL: IoIosCall,
  EMAIL: IoIosMail,
  TASK: IoIosPeople,
  MEET: IoMdCafe,
  LUNCH: IoMdRestaurant,
  DINNER: IoIosPaper
}

export default TaskIcons
